import { get, post, patch } from '../httpMethods';
import { ApiResponse, PaginationMeta } from '../../types/api';

export interface Visit {
  id: string;
  patientId: string;
  visitType: 'OPD' | 'IPD' | 'ER' | 'EXT';
  visitNumber: string;
  visitDate: string;
  visitEndDate?: string;
  status: 'ACTIVE' | 'COMPLETED' | 'CANCELLED' | 'DISCHARGED';
  departmentId?: string;
  referredBy?: string;
  createdBy: string;
  createdAt: string;
  updatedAt: string;
  patient?: {
    firstName: string;
    lastName: string;
    registrationNumber: string;
  };
}

export interface CreateVisitDto {
  patientId: string;
  type: 'OPD' | 'IPD' | 'ER' | 'EXT';
  departmentId?: string;
  referredById?: string;
  complaint?: string;
}

export interface UpdateVisitDto {
  status?: 'ACTIVE' | 'COMPLETED' | 'CANCELLED' | 'DISCHARGED';
  visitEndDate?: string;
}

export const visitService = {
  getVisits: (page = 1, limit = 20, filters?: { search?: string; visitType?: string; status?: string; dateFrom?: string; dateTo?: string }): Promise<ApiResponse<Visit[]> & { meta: PaginationMeta }> => {
    const params = new URLSearchParams({ page: String(page), limit: String(limit) });
    if (filters?.search) params.set('search', filters.search);
    if (filters?.visitType) params.set('visitType', filters.visitType);
    if (filters?.status) params.set('status', filters.status);
    if (filters?.dateFrom) params.set('dateFrom', filters.dateFrom);
    if (filters?.dateTo) params.set('dateTo', filters.dateTo);
    return get<Visit[]>(`/visits?${params.toString()}`) as Promise<ApiResponse<Visit[]> & { meta: PaginationMeta }>;
  },

  getVisit: (id: string): Promise<ApiResponse<Visit>> => {
    return get<Visit>(`/visits/${id}`);
  },

  createVisit: (data: CreateVisitDto): Promise<ApiResponse<Visit>> => {
    return post<Visit>('/visits', data);
  },

  updateVisit: (id: string, data: UpdateVisitDto): Promise<ApiResponse<Visit>> => {
    return patch<Visit>(`/visits/${id}`, data);
  },

  closeVisit: (id: string): Promise<ApiResponse<Visit>> => {
    return patch<Visit>(`/visits/${id}`, { status: 'COMPLETED', visitEndDate: new Date().toISOString() });
  },

  getActiveVisitsByPatient: (patientId: string): Promise<ApiResponse<Visit[]>> => {
    return get<Visit[]>(`/patients/${patientId}/active-visits`);
  },
};
